import type { BlockDefinition, BlockSerialized } from '#layers/block-engine/types/block';
import { useBlockAdapter } from '#layers/block-engine/composables/use-block-adapter';
import { getBuiltinBlocks } from '#layers/block-engine/utils/block/builtin-registry';

export function resolveSerializedBlock(blockId: string): Promise<BlockSerialized | undefined> {
	const { loadBlockSerialized } = useBlockAdapter();
	return loadBlockSerialized(blockId);
}

/**
 * Resolves builtin block definitions from the generated registry without
 * entering the async serialized-block resolution pipeline.
 */
export function resolveBuiltinBlock(blockId: string): BlockDefinition | undefined {
	return getBuiltinBlocks()[blockId];
}
